import React from 'react';
import { SectionHead, ProductFrame, Icon, CheckList } from './Primitives';
import './UnityDelivery.css';
export default function UnityDelivery({ assetBase, onTrial }) {
  return (
    <section className="ul-section ul-delivery ul-dark" id="deliver">
      <div className="ul-container">
        <div className="ul-delivery-grid">
          <div>
            <SectionHead
              eyebrow="02 / Deliver the whole learning journey"
              title={
                <>
                  From a programme
                  <br />
                  to people making progress.
                </>
              }
            >
              When you’re ready to run training, bring your learners, facilitators and learning
              evidence together in Unity.
            </SectionHead>
            <CheckList
              items={[
                'Reuse programmes across training cohorts',
                'Release learning, schedule sessions and manage assessments',
                'Give learners a clear next step and facilitators a useful view',
              ]}
            />
            <div className="ul-delivery-included">
              <Icon name="check" size={16} />
              <span>Adaptive complexity, badges and progress reporting included in Deliver.</span>
            </div>
          </div>
          <div className="ul-delivery-devices">
            <div className="ul-delivery-map">
              <ProductFrame
                src={`${assetBase}/product/learner-map-desktop.png`}
                width={1910}
                height={939}
                crop={[385, 28, 1134, 887]}
                alt="Unity programme map showing the current lesson and later sections"
                caption="Actual Unity programme map"
              />
            </div>
            <div className="ul-delivery-phone">
              <ProductFrame
                src={`${assetBase}/product/learner-lesson-mobile.png`}
                width={409}
                height={844}
                crop={[1, 85, 407, 741]}
                alt="A real Unity lesson displayed on a mobile screen"
              />
              <span className="ul-phone-caption">
                Learning that fits
                <br />
                into their day.
              </span>
            </div>
          </div>
        </div>
        <div className="ul-destination-strip">
          <div>
            <Icon name="download" size={26} />
            <div>
              <h3>Already have an LMS?</h3>
              <p>
                Create in Unity and export supported SCORM 1.2 study packages or branded outcome
                PDFs.
              </p>
            </div>
          </div>
          <a href="#pricing" className="ul-small-link">
            Explore Create plans <Icon size={17} />
          </a>
          <p className="ul-destination-note">
            Exports use saved English Base content for reading and review. Native interactions,
            adaptive delivery, games and Unity assessment scoring stay in Unity.
          </p>
        </div>
      </div>
    </section>
  );
}
